/*
 * Copyright (c) 2019. Unconventional Software Corporation
 */

/**
 * Data model class for a help topic.
 */
export class HelpTopic {

  /**
   * Constructor.
   *
   * @param id
   *  - id of the help topic
   * @param title
   *  - title of the topic
   * @param description
   *  - description of the topic; default is null
   * @param order
   *  - order that the topic should be displayed in (starting at 0); default is 0
   * @param url
   *  - URL of the video (if applicable); default is null
   */
  constructor(public id: string,
              public title: string,
              public description: string = null,
              public order: number = 0,
              public url: string = null) {

  }

  static fromJson(key: string, {description, order, title, url}) {
    return new HelpTopic(key, title, description, order, url);
  }

  static fromSnapshots(data: any) {
    return data.map(snap => HelpTopic.fromJson(snap.key, snap.payload.val()));
  }
}



// WEBPACK FOOTER //
// ./src/providers/help/HelpTopic.ts